import { render, staticRenderFns } from "./StatisticalReportList.vue?vue&type=template&id=40965477&scoped=true&"
import script from "./StatisticalReportList.vue?vue&type=script&lang=ts&"
export * from "./StatisticalReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40965477",
  null
  
)

export default component.exports